module.exports = __webpack_public_path__ + "static/img/4-3b.0f34f2f8.png";